import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Location } from "react-router-dom";
import usePrevious from "../../utils/usePrevious";

import routing from "../../routing";
import { IProps } from "./interfaces";

const isSameRoot = (location: Location, previousLocation: Location, route: "plan" | "publicPlan") => {
    if (
        location.pathname.slice(1, routing[route].length + 1) === routing[route] &&
        location.pathname.slice(1, routing[route].length + 2 + 24) ===
            previousLocation.pathname.slice(1, routing[route].length + 2 + 24)
    ) {
        return true;
    }
    return false;
};

const ScrollToTop = ({ children }: IProps) => {
    const location = useLocation();
    const previousLocation = usePrevious(location)!;
    useEffect(() => {
        if (
            previousLocation &&
            (isSameRoot(location, previousLocation, "plan") || isSameRoot(location, previousLocation, "publicPlan")) &&
            !location.pathname.includes(routing.tasks)
        ) {
            return;
        }
        if (window.historyList && window.historyList[window.historyList.length - 1]?.action !== "POP") {
            window.scrollTo(0, 0);
        }
    }, [location.pathname])

    return children;
}

export default ScrollToTop;
